import PropTypes from 'prop-types'
import { useState } from 'react'
import Spinner from 'react-bootstrap/Spinner'
import { NumericFormat } from 'react-number-format'
import Precios from '../reutilizables/precios/Precios'

const PresupuestoFormItemList = ({ item, idEstado, onDelete, canAdministrate }) => {
  const [clicked] = useState(false)

  return (
    <div>
      <div className="row">
        <div className="col">{item.descripcion}</div>
        <div className="col text-right">
          <NumericFormat
            value={item.cantidad}
            displayType={'text'}
            thousandSeparator={false}
            decimalSeparator={'.'}
            fixedDecimalScale={true}
            decimalScale={2}
          />
        </div>
        <div className="col d-flex justify-content-end">
          <Precios
            precio={item.precio}
            monedaSimbolo={item.monedaSimbolo}
            unidadMedida={item.unidadMedida}
          />
        </div>
        <div className="col">{item.unidadMedida}</div>
        <div className="col d-flex justify-content-end">
          <Precios precio={item.total} monedaSimbolo={item.monedaSimbolo} />
        </div>
        <div className="col text-right">{item.alicuota ?? 0}%</div>
        <div className="col text-right">
          {idEstado === 0 && canAdministrate && (
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={() => onDelete(item.idPresupuestoItem)}
            >
              {clicked ? <Spinner animation="border" role="status" /> : 'Quitar'}
            </button>
          )}
        </div>
      </div>
      <hr />
    </div>
  )
}

PresupuestoFormItemList.propTypes = {
  item: PropTypes.shape({
    descripcion: PropTypes.string.isRequired,
    cantidad: PropTypes.number.isRequired,
    precio: PropTypes.number.isRequired,
    monedaSimbolo: PropTypes.string,
    unidadMedida: PropTypes.string,
    total: PropTypes.number.isRequired,
    idPresupuestoItem: PropTypes.number.isRequired,
    alicuota: PropTypes.number
  }).isRequired,
  idEstado: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  canAdministrate: PropTypes.bool.isRequired
}

export default PresupuestoFormItemList
